import { render, staticRenderFns } from "./home-screen-controller.vue?vue&type=template&id=1670c4b0&scoped=true"
import script from "./home-screen-controller.vue?vue&type=script&lang=js"
export * from "./home-screen-controller.vue?vue&type=script&lang=js"
import style0 from "./home-screen-controller.vue?vue&type=style&index=0&id=1670c4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670c4b0",
  null
  
)

export default component.exports